import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const ActionButtons = ({ bookingData }) => {
  const navigate = useNavigate();

  const handleAddToCalendar = () => {
    const title = `Consultation with ${bookingData?.professionalName}`;
    const description = `Service: ${bookingData?.serviceType}\nBooking Ref: ${bookingData?.referenceNumber}\nContact: ${bookingData?.professionalEmail}`;
    const location = 'To be confirmed by professional';

    const startDate = bookingData?.preferredDate
      ? new Date(bookingData.preferredDate)
      : new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
    const endDate = new Date(startDate.getTime() + 60 * 60 * 1000);

    const formatDate = (date) => date?.toISOString()?.replace(/[-:]/g, '')?.split('.')?.[0] + 'Z';

    const icsContent = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//ListingLen//Consultation//EN',
      'BEGIN:VEVENT',
      `UID:${bookingData?.referenceNumber}@listinglen.com`,
      `DTSTAMP:${formatDate(new Date())}`,
      `DTSTART:${formatDate(startDate)}`,
      `DTEND:${formatDate(endDate)}`,
      `SUMMARY:${title}`,
      `DESCRIPTION:${description}`,
      `LOCATION:${location}`,
      'END:VEVENT',
      'END:VCALENDAR'
    ]?.join('\r\n');

    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `consultation-${bookingData?.referenceNumber}.ics`;
    document.body?.appendChild(link);
    link?.click();
    document.body?.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="flex flex-col sm:flex-row gap-3">
      <button
        onClick={handleAddToCalendar}
        className="flex-1 flex items-center justify-center gap-2 py-3.5 px-6 rounded-xl font-semibold text-sm transition-all duration-200"
        style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)', color: '#00D4FF' }}
      >
        <Icon name="CalendarPlus" size={18} />
        Add to Calendar
      </button>
      <button
        onClick={() => navigate('/professional-marketplace')}
        className="flex-1 flex items-center justify-center gap-2 py-3.5 px-6 rounded-xl font-semibold text-sm transition-all duration-200"
        style={{ background: 'linear-gradient(135deg, #00D4FF, #0099CC)', color: '#000', boxShadow: '0 0 15px rgba(0,212,255,0.3)' }}
      >
        <Icon name="Store" size={18} />
        Return to Marketplace
      </button>
    </div>
  );
};

export default ActionButtons;
